export default __webpack_public_path__ + "static/media/kelasku.3127a409.svg";